<template>
    <td>
        <div style="display:inline-block; position:relative;">
            <input type="number" class="form-control" style="width: 60px; display: inline-block" v-model="data.singlecarrier.app_goal"
                   v-bind:disabled="isDisabled"
            ></input>
            <div style="position:absolute; left:0; right:0; top:0; bottom:0; z-index: 100;"
                 v-if="showSwitcher"
                 @click="data.singlecarrier.set_by_goals = true"></div>
        </div>
    </td>
</template>

<script>
export default {
    props: [
        'data'
    ],
    computed: {
        isDisabled() {
            if (this.data.auto_app_goals) {
                return !this.data.singlecarrier.set_by_goals || !['driverboost', 'driverboost+jb', 'mc+driverboost', 'mc+driverboost+jb', 'jobadviser', 'uncapped_jb', 'direct'].includes(this.data.auto_lead_type);
            }
            else {
                return false;
            }
        },
        showSwitcher() {
            if (this.data.auto_app_goals) {
                return !this.data.singlecarrier.set_by_goals && ['driverboost', 'driverboost+jb', 'mc+driverboost', 'mc+driverboost+jb', 'jobadviser', 'uncapped_jb', 'direct'].includes(this.data.auto_lead_type);
            }
            else {
                return false;
            }
        }
    }
}
</script>